<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <active-dashboard
      :info="reserveStatus"
      @edit="editReserveInfo"
    />

    <v-dialog
      v-model="activeDialog"
      max-width="500px"
      persistent
    >
      <base-form
        :editing-object="reserveStatus"
        :schema="schemas"
        @close="activeDialog=false"
        @submit="saveUserInfo"
      >
        <div>{{ $t('PlannedSettings') }}</div>
        <template #subtitle>
          {{ $t('PlannedSettingsHint') }}
        </template>
      </base-form>
    </v-dialog>
  </div>
</template>

<script>
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import ActiveDashboard from '@/views/AadenPages/settings/reserveSetting/reserveDashboard/ActiveDashboard.vue'
import { VSelect } from 'vuetify/lib/components'
import { getReservationUserCloudList, updateReservationInfo } from '@/model/dataLayer/api/newReservation/reservation'

export default {
  name: 'OpenReserve',
  components: {
    ActiveDashboard,
    BaseForm
  },
  props: {
    info: {}
  },
  data: function () {
    return {
      ifEdit: -1,
      reservationInfo: null,
      openUserList: null,
      activeDialog: false,
      reserveStatus: null
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'subDomainName',
          name: 'SubdomainLink',
          componentProps: {
            disabled: true,
            rules: [
              v => !!v || this.$t('hostCantEmpty'),
              v => !this.openUserList.find(
                it => it.subDominName !== this.reserveStatus.subDominName && it.subDominName === v) ||
                  this.$t('thisHostnameAlreadyUse')
            ]
          }
        },
        {
          key: 'mapUrl',
          name: 'GoogleMapsLink',
          componentProps: {
            rules: [
              v => !!v || this.$t('hostCantEmpty'),
              v => /https:\/\//.test(v) || '"https://" Error'
            ]
          }
        },
        {
          key: 'autoConfirmReservation',
          hint: 'AutoConfirmReservationHint',
          component: VSelect,
          componentProps: {
            items: [
              { text: 'Yes', value: true },
              { text: 'No', value: false }
            ]
          }
        },
        {
          key: 'allowOnlyOneActiveReservation',
          hint: 'AllowOnlyOneActiveReservationHint',
          component: VSelect,
          componentProps: {
            items: [
              { text: 'Yes', value: true },
              { text: 'No', value: false }
            ]
          }
        },
        {
          key: 'maxReservationPerSlot',
          hint: 'MaxReservationPerSlotHint'
        },
        {
          key: 'reservationTimeLimit',
          hint: 'reservationTimeLimitHint'
        },
        {
          key: 'safeCancelTimeHours',
          hint: '时间内全额退款'
        },
        {
          key: 'partlyCancelTimeHours',
          hint: '比例退款的时间'
        },
        {
          key: 'partlyCancelRefundPercentage',
          hint: '退款的比例'
        },
        {
          key: 'stripeConnectKey',
          hint: 'stripeConnectKey',
          required: false
        },
        {
          key: 'businessHourOffset',
          hint: 'businessHourOffset'
        }
      ]
    }

  },
  watch: {
    activeDialog (val) {
      if (!val) {
        this.reload()
      }
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async saveUserInfo (info) {
      await updateReservationInfo(info)
      this.activeDialog = false
    },
    editReserveInfo () {
      this.activeDialog = true
    },
    async reload () {
      this.openUserList = await getReservationUserCloudList()
      this.reserveStatus = this.info
      if (this.reserveStatus) {
        const hostName = 'https://' + this.info.subDominName + '.reservation.aaden.io'
        this.QRCode = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + hostName
      }
    }
  }
}
</script>

<style scoped>

</style>
